import * as requestFromServer from '../common/cruds'
import { InspectionCompanySlices } from './slices'
import { handleNotificationWithToastify } from '../../../app/services/Functional'
import { callTypes, catchError, endCall, startCall } from '../common/slices'

const actions = InspectionCompanySlices.actions
const API_URL = `${process.env.REACT_APP_API_BASE_URL}inspection_companies/`
const PLANS_API_URL = `${process.env.REACT_APP_API_BASE_URL}subscription_plans/plans/company`

export const getInspectionCompanyById = (id: string, type: string) => (dispatch: any) => {
  dispatch(startCall({ callType: callTypes.action }))
  return requestFromServer
    .getRequest(`${API_URL}${id}/${type}`)
    .then(response => {
      dispatch(endCall({ callType: callTypes.action }))
      dispatch(actions.inspectionCompany(response.data.data))
      return response.data.data
    })
    .catch(error => {
      error.clientMessage = 'Can\'t find inspection company'
      dispatch(catchError({ error, callType: callTypes.action }))
    })
}

export const resetInspectionCompany = () => (dispatch: any) => {
  return dispatch(actions.inspectionCompany({ inspection_company: null }))
}

export const createInspectionCompany = (payload: any) => (dispatch: any) => {
  dispatch(startCall({ callType: callTypes.action }))
  return requestFromServer
    .postRequest(`${API_URL}`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(response => {
      dispatch(endCall({ callType: callTypes.action }))
      handleNotificationWithToastify(response.data)
      return response.data
    })
    .catch(error => {
      error.clientMessage = 'Can\'t create inspection company'
      dispatch(catchError({ error, callType: callTypes.action }))
      return error
    })
}

export const updateInspectionCompany = (inspectionCompany: any) => (dispatch: any) => {
  dispatch(startCall({ callType: callTypes.action }))
  return requestFromServer
    .patchRequest(`${API_URL}${inspectionCompany.get('id')}`, inspectionCompany, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(response => {
      dispatch(endCall({ callType: callTypes.action }))
      handleNotificationWithToastify(response.data)
      return response.data
    })
    .catch(error => {
      error.clientMessage = 'Can\'t update inspection company'
      dispatch(catchError({ error, callType: callTypes.action }))
      return error
    })
}

export const inspectionCompaniesList = () => (dispatch: any) => {
  dispatch(startCall({ callType: callTypes.action }))
  return requestFromServer
    .getRequest(`${API_URL}dropdown`)
    .then(response => {
      dispatch(endCall({ callType: callTypes.action }))
      dispatch(actions.inspectionCompaniesList(response.data.data))
    })
    .catch(error => {
      error.clientMessage = 'Can\'t get group list'
      dispatch(catchError({ error, callType: callTypes.action }))
    })
}

export const inspectionCompaniesPlanList = () => (dispatch: any) => {
  dispatch(startCall({ callType: callTypes.action }))
  return requestFromServer
    .getRequest(`${PLANS_API_URL}`)
    .then(response => {
      dispatch(endCall({ callType: callTypes.action }))
      dispatch(actions.inspectionCompaniesPlanList(response.data.data))
    })
    .catch(error => {
      error.clientMessage = 'Can\'t get plan list'
      dispatch(catchError({ error, callType: callTypes.action }))
    })
}